import React from 'react';
import { Typography, Box } from '@mui/material';

interface CardHeaderProps {
    title: string;
    subtitle: string;
    action?: React.ReactNode;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ title, subtitle, action }) => (
    <div className="card-title" style={{ paddingTop: '8px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Box>
                <Typography variant="h6" component="h2" className="card-title-text">
                    {title}
                </Typography>
                <Typography variant="subtitle1" className="card-subtitle-text">
                    {subtitle}
                </Typography>
            </Box>
            {action && (
                <Box sx={{ marginLeft: 'auto' }}>
                    {action}
                </Box>
            )}
        </Box>
    </div>
);